import { useMutation } from '@apollo/client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useSnackbar } from 'notistack';
import React from 'react';
import { red } from '@mui/material/colors';
import { DELETE_DRAFT } from '../../../helpers/graphql/drafts';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

export default function DraftDeleteDialog({
  btnText,
  setOpen,
  id,
  setPosts,
  posts,
  onDelete,
}) {
  const [deleteDraft] = useMutation(DELETE_DRAFT);

  const { enqueueSnackbar } = useSnackbar();

  const handleSetDeleted = () => {
    if (onDelete) onDelete();
    else {
      const newPosts = [];
      posts.forEach(post => {
        if (post.id !== id) {
          newPosts.push(post);
        }
      });
      setPosts(newPosts);
    }
  };

  const handleDeleteForever = () => {
    deleteDraft({
      variables: {
        id,
      },
    })
      .then(({ data }) => {
        if (data.deleteDraft.success) {
          handleSetDeleted();
          setOpen(undefined);
        } else {
          enqueueSnackbar(
            `Draft could not be deleted: ${data.deleteDraft.message}`,
            {
              variant: 'error',
            },
          );
        }
      })
      .catch(() => {
        enqueueSnackbar('Draft could not be deleted', {
          variant: 'error',
        });
      });
  };

  return (
    <Dialog
      open={id !== undefined}
      onClose={() => setOpen(undefined)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{btnText}?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure that you want to delete the draft &quot;
          {posts.map(draft => {
            if (draft.id === id) return draft.title || 'Untitled Draft';
          })}
          &quot;? Deleted drafts cannot be restored.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(undefined)} color="primary">
          Cancel
        </Button>{' '}
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Button
              variant="contained"
              onClick={handleDeleteForever}
              color="primary"
            >
              <DeleteForeverIcon />
              {btnText}
            </Button>
          </ThemeProvider>
        </StyledEngineProvider>
      </DialogActions>
    </Dialog>
  );
}
